import React, { useState } from 'react';
import styles from './_image_carousel.module.scss';

const ImageCarousel = ({ images, imageClassName, imageStyle }) => {
  const [index, setIndex] = useState(0);

  if (images.length === 0) {
    return null;
  }

  const image = (
    <img
      src={images[index].url}
      className={imageClassName}
      style={imageStyle}
      alt={images[index].alt}
      data-widget-element="preview-image"
    />
  );

  if (images.length === 1) {
    return image;
  }

  const show = (nextIndex) => setIndex((nextIndex + images.length) % images.length);

  return (
    <div className={styles.carousel} data-widget-element="image-carousel">
      <div className={styles.imageArea}>
        {image}
        <button
          type="button"
          className={`${styles.arrow} ${styles.previous}`}
          aria-label={t('quote_builder_widget.previous_image')}
          onClick={() => show(index - 1)}
          data-widget-element="image-carousel-previous"
        >
          &#8249;
        </button>
        <button
          type="button"
          className={`${styles.arrow} ${styles.next}`}
          aria-label={t('quote_builder_widget.next_image')}
          onClick={() => show(index + 1)}
          data-widget-element="image-carousel-next"
        >
          &#8250;
        </button>
      </div>
      <div className={styles.dots}>
        {images.map((dotImage, dotIndex) => (
          <button
            key={dotImage.url}
            type="button"
            className={dotIndex === index ? `${styles.dot} ${styles.shownDot}` : styles.dot}
            aria-label={t('quote_builder_widget.show_image', { number: dotIndex + 1 })}
            aria-current={dotIndex === index ? 'true' : undefined}
            onClick={() => show(dotIndex)}
            data-widget-element="image-carousel-dot"
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
